import {
  ApiException,
  FirebaseUserModel,
  Notification,
  SnackbarType,
} from '../../../types';
import { create } from 'zustand';

interface ZustandState {
  snackbar: SnackbarType;
  setSnackbar: (snackbar: SnackbarType) => void;
  error: ApiException;
  setError: (error: ApiException) => void;
  openShowable: boolean;
  setOpenShowable: (openShowable: boolean) => void;
  setCloseShowable: () => void;
  firebaseUser: FirebaseUserModel;
  setFirebaseUser: (user: FirebaseUserModel) => void;
  colorMode: 'light' | 'dark';
  setColorMode: (colorMode: 'light' | 'dark') => void;
  notifications: Notification[];
  setNotifications: (notifications: Notification[]) => void;
  userIndexingIsDisabled: boolean;
  setUserIndexingIsDisabled: (isDisabled: boolean) => void;
  groupIndexingIsDisabled: boolean;
  setGroupIndexingIsDisabled: (isDisabled: boolean) => void;
  calendarIndexingIsDisabled: boolean;
  setCalendarIndexingIsDisabled: (isDisabled: boolean) => void;
  orgIndexingIsDisabled: boolean;
  setOrgIndexingIsDisabled: (isDisabled: boolean) => void;

  // AUTH
  // isAuthed: boolean;
  // setIsAuthed: (isAuthed: boolean) => void;
  // isLoggedOut: boolean;
  // setIsLoggedOut: (isLoggedOut: boolean) => void;
  // idToken: string;
  // setIdToken: (idToken: string) => void;
}

export const useStore = create<ZustandState>()((set) => ({
  snackbar: {
    open: false,
    severity: 'success',
    message: '',
  },
  error: {
    message: '',
    header: '',
    exceptionType: 'Default',
    isShowable: false,
    isAccessException: false,
  },
  openShowable: false,
  firebaseUser: {
    firebaseUserId: '',
    firebaseDbPath: '',
    userEmail: '',
    primaryDomain: '',
    alive: 0,
    lastKeepAliveMessageSent: 0,
  },
  userIndexingIsDisabled: false,
  groupIndexingIsDisabled: false,
  calendarIndexingIsDisabled: false,
  orgIndexingIsDisabled: false,
  setSnackbar: (snackbar: SnackbarType) => set(() => ({ snackbar })),
  setError: (error: ApiException) => set(() => ({ error })),
  setOpenShowable: (openShowable: boolean) => set(() => ({ openShowable })),
  setCloseShowable: () => set(() => ({ openShowable: false })),
  setFirebaseUser: (firebaseUser: FirebaseUserModel) =>
    set(() => ({ firebaseUser })),
  colorMode: 'light',
  setColorMode: (colorMode: 'light' | 'dark') => set(() => ({ colorMode })),
  notifications: [],
  setNotifications: (notifications: Notification[]) =>
    set(() => ({ notifications })),
  setUserIndexingIsDisabled: (isDisabled: boolean) =>
    set(() => ({ userIndexingIsDisabled: isDisabled })),
  setGroupIndexingIsDisabled: (isDisabled: boolean) =>
    set(() => ({ groupIndexingIsDisabled: isDisabled })),
  setCalendarIndexingIsDisabled: (isDisabled: boolean) =>
    set(() => ({ calendarIndexingIsDisabled: isDisabled })),
  setOrgIndexingIsDisabled: (isDisabled: boolean) =>
    set(() => ({ orgIndexingIsDisabled: isDisabled })),

  // AUTH
  // isAuthed: false,
  // setIsAuthed: (isAuthed: boolean) => set(() => ({ isAuthed })),
  // isLoggedOut: false,
  // setIsLoggedOut: (isLoggedOut: boolean) => set(() => ({ isLoggedOut })),
  // idToken: '',
  // setIdToken: (idToken: string) => set(() => ({ idToken })),
}));
